var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPath2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 10,
    viewBox: "0 0 24 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8067 0C16.5402 0.000444824 15.3044 0.292254 14.2661 0.836048C13.2277 1.37984 12.4368 2.14945 12 3.041C11.4979 2.01841 10.5323 1.16085 9.27216 0.618432C8.012 0.0760134 6.53761 -0.116696 5.10709 0.0740397C3.67657 0.264775 2.38109 0.826802 1.44741 1.66173C0.513734 2.49666 0.00136547 3.55129 0 4.641C0.00599965 5.59285 0.21902 6.5376 0.630667 7.438H8.556L11.1787 10L14.8827 4.454L17.2107 7.437H23.3707C23.7811 6.53813 23.9937 5.59512 24 4.645C24 3.41307 23.3475 2.2316 22.186 1.36049C21.0245 0.489383 19.4492 0 17.8067 0V0Z",
    fill: "#6D7278"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath2);
export default __webpack_public_path__ + "static/media/Path2.eb417917e998bfba3e885c05357b434f.svg";
export { ForwardRef as ReactComponent };